import { updateWorkOrderMainItem, updateWorkOrderTabItem, workOrdersSettingsGetWorkOrder } from '../../../../../.globals/redux/actions'

export class WORKORDER {
    execute = (payload, state, dispatch) => {
        if (!payload || !state) return;

        const { id, key } = payload;
        const {
            workOrdersTrackerTabRedux: { workOrdersGrouped: mainWorkOrders = [], totalWorkOrdersGrouped: mainTotal } = {},
            workOrdersWorkOrderTabRedux: { workOrders: tabWorkOrders = [], totalWorkOrders: tabTotal } = {}
        } = state;

        const { workOrdersCreateEditWorkOrderRedux: { open = false, workOrderId = null } } = state;

        const isUpdate = ["DELETE", "UPDATE"].includes(key);
        const existsInMain = mainWorkOrders.some(order => order.id === id);
        const existsInTab = tabWorkOrders.some(order => order.id === id);

        if (open && id == workOrderId) {
            dispatch(workOrdersSettingsGetWorkOrder({ id: id }));
        }
        if (isUpdate && existsInMain) {
            dispatch(updateWorkOrderMainItem({ id, key, items: mainWorkOrders, total: mainTotal }));
        }
        if (isUpdate && existsInTab) {
            dispatch(updateWorkOrderTabItem({ id, key, items: tabWorkOrders, total: tabTotal }));
        }
    };
}

